import { Link } from "react-router-dom";

const Navbar = ({ step, setStep }: { step: number; setStep: any }) => {
  const timelineData = [
    {
      id: 1,
      title: "آزمایش‌دهنده",
      subtitle: "آزمایش چه کسی رو تحلیل می‌کنی؟ ",
    },
    {
      id: 2,
      title: "ثبت آزمایش",
      subtitle: "آزمایشت رو اینجا بسپر دست ما!",
    },
    {
      id: 3,
      title: "شروع تحلیل",
      subtitle: "نوع تحلیل رو انتخاب کن که شروع کنیم.",
    },
  ];

  const timelineHandler = (id: number) => {
    if (id < step) setStep(id);
  };

  return (
    <div className="w-full">
      <div className="breadcrumbs text-sm mb-4">
        <ul>
          <li>
            <Link to="/">صفحه اصلی</Link>
          </li>
          <li className="font-[900]">تحلیل آزمایش پزشکی</li>
        </ul>
      </div>

      <div className="border w-full p-5 px-0 lg:px-5 mb-5 rounded-2xl">
        <div className="w-full mx-auto flex justify-center">
          <ul className="steps w-full">
            {timelineData.map((timelineItem) => (
              <li
                onClick={() => timelineHandler(timelineItem.id)}
                className={`step ${
                  step >= timelineItem.id ? "step-primary" : ""
                } `}
                key={timelineItem.id}
              >
                <h6 className="font-rokh font-[700] mt-3 text-sm lg:text-base">
                  {timelineItem.title}
                </h6>
                <span className="font-rokh font-[500] text-sm mx-5 lg:mx-10 hidden lg:inline">
                  {timelineItem.subtitle}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
